import { FC, useRef, useState } from "react";
import { ImageCollection } from "common/config/media.config";
import useProfile from "common/hooks/useProfile";
import useOnClickOutside from "common/hooks/useOnClickOutside";
import Avatar from "common/components/base/avatar";
import { useAppDispatch } from "common/redux/core";
import { userActions } from "common/redux/user";
import LogoutIcon from "@mui/icons-material/Logout";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import "./TopHeader.scss";

const TopHeader: FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const { avatar, displayName } = useProfile();
  const [showProfileOptions, setShowProfileOptions] = useState(false);

  useOnClickOutside(ref, () => {
    setShowProfileOptions(false);
  });

  return (
    <header className="top-header">
      <div className="top-header__left">
        <div className="top-header__logo">
          <a href="/">
            <img src={ImageCollection.XM_LOGO_SMALL} alt="EY Logo" />
          </a>
        </div>
        <span className="top-header__app-name">
          Engineering Inf. Management
        </span>
      </div>

      <div className="top-header__right">
        <button className="top-header__icon-btn" aria-label="Notifications">
          <NotificationsNoneOutlinedIcon />
        </button>
        <button className="top-header__icon-btn" aria-label="Help">
          <HelpOutlineOutlinedIcon />
        </button>
        <button className="top-header__icon-btn" aria-label="Settings">
          <SettingsOutlinedIcon />
        </button>
        <button className="top-header__icon-btn" aria-label="More">
          <MoreHorizIcon />
        </button>
        <div
          className="top-header__avatar"
          ref={ref}
          onClick={() => setShowProfileOptions(!showProfileOptions)}
        >
          <Avatar userName={displayName} src={avatar} />
          {showProfileOptions && (
            <div className="top-header__avatar-options">
              <div className="top-header__profile-section">
                <Avatar
                  userName={displayName}
                  src={avatar}
                  size="large"
                  className="header-avatar"
                />
                <div className="top-header__profile-name">
                  <p>{displayName}</p>
                </div>
              </div>
              <div className="top-header__logout">
                <a
                  onClick={() => {
                    dispatch(userActions.logoutUserBegin());
                  }}
                >
                  <LogoutIcon />
                  <span>Log Out</span>
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="top-header__accent-line" />
    </header>
  );
};

export default TopHeader;
